import React from "react";
import CustomButton from "../CustomButton";
import { setOpenAuthSidebar } from "../../../redux/features/settingSlice";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { useAppDispatch } from "../../../hooks/useRedux";
import { useTheme } from "@mui/material";
import HamMenuIcon from "../../../media/images/icons/hambergerMenu";

interface Props {
  sidbarHandler: ActionCreatorWithPayload<
    boolean,
    "setting/setOpenAuthSidebar"
  >;
}

export default function HambergerMenuButton(props: Props) {
  const { sidbarHandler } = props;

  const dispatch = useAppDispatch();
  const theme = useTheme();
  return (
    <CustomButton
      onClick={() => dispatch(sidbarHandler(true))}
      bgColor={theme.palette.secondary[50]}
      gap="0px"
      height="fit-content"
      fSize="16px"
      borderColor={"secondary.main"}
      fWeight="700"
      px="8px"
      py="8px"
      borderRadius="8px"
      icon2={<HamMenuIcon size={18} color={theme.palette.secondary.main} />}
    />
  );
}
